import script from "./footer-vue.vue?vue&type=script&setup=true&lang=js"
export * from "./footer-vue.vue?vue&type=script&setup=true&lang=js"

import "./footer-vue.vue?vue&type=style&index=0&id=894c4f7a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-894c4f7a"]])

export default __exports__